if (!customElements.get('size-guide-switcher')) {
  customElements.define(
    'size-guide-switcher',
    class SizeGuideSwitcher extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabItems = this.querySelectorAll('.size-guide__tab-item');
        this.tabs = this.querySelectorAll('.size-guide__tab');

        if (this.tabItems.length < 2) return;
        this.tabItems.forEach((it) => {
          const btn = it.querySelector('.size-guide__tab-btn');
          const tab = this.querySelector(`#${btn.dataset.target}`);

          btn.addEventListener('click', this.onTabBtnClick.bind(this, it, tab));
        });
      }

      onTabBtnClick(item, tab) {
        this.tabItems.forEach((it) => it.classList.remove('size-guide__tab-item--active'));
        item.classList.add('size-guide__tab-item--active');

        this.tabs.forEach((t) => t.classList.remove('size-guide__tab--active'));
        tab.classList.add('size-guide__tab--active');
      }
    },
  );
}
